<template>
    <router-view v-slot="{ Component }">
        <!-- <keep-alive :include="store.keepLiiveRoute"> -->
        <Component :is="Component"></Component>
        <!-- </keep-alive> -->
    </router-view>
</template>
<script setup>
import { onMounted, watch, ref } from 'vue';

onMounted(() => {
    const script = document.createElement('script');
    script.src =
        'https://s4.cnzz.com/z_stat.php?id=1278739919&web_id=1278739919';
    script.language = 'JavaScript';
    document.body.appendChild(script);
});
</script>

<style lang="scss">
#app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    color: #fff;
    background: #fdf7f5;
    font-size: 14px;
    margin: 0;
    padding: 0;
}
</style>
